// Google Analytics 4 (propiedad pacifictourcr.com).
// Solo mide en el sitio real: en localhost y vistas previas no manda nada,
// para no mezclar pruebas con visitas reales.
const DOMINIOS_REALES = ['www.pacifictourcr.com', 'pacifictourcr.com'];
const ES_SITIO_REAL =
  typeof window !== 'undefined' && DOMINIOS_REALES.includes(window.location.hostname);

const GA_ID = ES_SITIO_REAL ? process.env.REACT_APP_GA_ID || 'G-38S3XG2KVE' : null;

let iniciado = false;

export function iniciarAnalytics() {
  if (!GA_ID || iniciado || typeof window === 'undefined') return;
  iniciado = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  // Las visitas se mandan a mano en cada cambio de página (SPA).
  window.gtag('config', GA_ID, { send_page_view: false });

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(s);
}

export function registrarVisita(path) {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function registrarEvento(nombre, parametros = {}) {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', nombre, parametros);
}
